export default __webpack_public_path__ + "static/media/80.654cc5d4.png";